module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq580-991afe103d8abba9aef65cd65409bca4.jpg";